export default __webpack_public_path__ + "static/media/thumbnail.82921696.png";